import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface CommonCustomTableContainerStyles {
    container?: InjectableCss;
}

export const CommonCustomTableContainerStyles: CommonCustomTableContainerStyles = {
    container: {
        css: css`
                table {
                    th {
                        background-color:#ccc !important;
                        &.th-width-15{
                            width: 15%;
                        }
                        &.th-width-10{
                            width: 10%;
                        }
                    }
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        overflow-x: auto;
                        white-space: nowrap;
                    `,
                    css`
                        width: 100%;
                        overflow-x: auto;
                        white-space: nowrap;
                    `,
                    css`
                        width: 100%;
                        overflow-x: auto;
                        white-space: nowrap;
                    `,
                    null,
                    null,
                ])}
    }
        `,
    },
};

const styles = CommonCustomTableContainerStyles;

const CommonCustomTableContainer: React.FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="CommonCustomTable">
            <Zone contentId={id} zoneName="Content1" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CommonCustomTableContainer,
    definition: {
        displayName: "Common Custom Table Container",
        group: "Common",
    },
};

export default widgetModule;
